import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rtname: ''
  },
  mutations: {
    // SET_RTNAME (state, val) {
    //   state.rtname = val
    // }
  },
  actions: {

  }
})
